import React from 'react';
import { Reveal } from '../Reveal';
import { SectionBand, Eyebrow } from './SectionBand';
import { Cta } from '../Cta';
import { useScore } from '../ScoreContext';
const steps = [{
  n: '1',
  title: 'Get your Reader-to-Revenue Score',
  line: '8 questions about what happens after someone reads your book.'
}, {
  n: '2',
  title: 'Audit the reader path',
  line: 'A deeper look at whether the path is worth building.'
}, {
  n: '3',
  title: 'Decide whether to build',
  line: 'No pressure. Decide once the opportunity is clear.'
}];
export function ScoreAuditBuild() {
  const {
    openDiagnostic
  } = useScore();
  return <SectionBand tone="paperDark" width="default" data-id="element-871" data-mp="2hcmxxh0ah25l">
      <div className="mx-auto max-w-2xl text-center" data-id="element-872" data-mp="2cetrcmv2q64s">
        <Reveal data-id="element-873" data-mp="2cebnp5630pmu">
          <Eyebrow data-id="element-874" data-mp="2cgxx7acj9f7p">How it works</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl leading-[1.08] text-navy md:text-5xl" data-id="element-875" data-mp="15zas50kyy9gs">
            Get the score before you
            <br data-id="element-876" data-mp="10ywtua966dvy" />
            <span className="italic text-seaglass" data-id="element-877" data-mp="10yd9kmw1rder">decide what to build</span>
          </h2>
        </Reveal>
      </div>

      <Reveal delay={0.1} data-id="element-878" data-mp="18f5rerqhghgu">
        <div className="mt-14 grid gap-5 md:grid-cols-3 md:gap-6" data-id="element-879" data-mp="1cj3rp5rjnybh">
          {steps.map(step => <div key={step.n} className="relative rounded-3xl border border-gray-200 bg-white p-7 text-center" data-id="element-880" data-mp="yj2qfp7daovh">
              <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-seaglass font-serif text-xl text-white" data-id="element-881" data-mp="13hdypvi0krbl">
                {step.n}
              </div>
              <h3 className="mt-5 font-serif text-xl text-navy" data-id="element-882" data-mp="tjpveh6cebht">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-text-muted" data-id="element-883" data-mp="tlkerr1ytvjs">
                {step.line}
              </p>
            </div>)}
        </div>
      </Reveal>

      <Reveal delay={0.15} data-id="element-884" data-mp="ks7eu55hhto7">
        <div className="mt-12 flex flex-col items-center gap-3" data-id="element-885" data-mp="kpbhahxjt70a">
          <Cta variant="primary" showArrow onClick={openDiagnostic} className="px-10 py-4 text-lg" data-id="element-886" data-mp="5vg9zgd1jpr7">
            Get Your Reader-to-Revenue Score
          </Cta>
          <p className="text-sm font-medium text-text-muted" data-id="element-887" data-mp="3ntr3ppcxr6j6">
            Start with the Score. The rest follows only if it fits.
          </p>
        </div>
      </Reveal>
    </SectionBand>;
}